import { ActionType } from 'typesafe-actions';
import { put, select, takeEvery } from 'redux-saga/effects';

import { IChecklistAnswerType } from 'APIPackage/CatalogsModule/interfaces/IChecklistAnswerType';
import { IKnmAddressType } from 'APIPackage/CatalogsModule/interfaces/IKnmAddressType';
import { IKnmDelegateType } from 'APIPackage/CatalogsModule/interfaces/IKnmDelegateType';
import { IKnmDocumentType } from 'APIPackage/CatalogsModule/interfaces/IKnmDocumentType';
import { IKnmExecutionType } from 'APIPackage/CatalogsModule/interfaces/IKnmExecutionType';
import { IKnmExpertType } from 'APIPackage/CatalogsModule/interfaces/IKnmExpertType';
import { IKnmInspectorType } from 'APIPackage/CatalogsModule/interfaces/IKnmInspectorType';
import { IKnmLinkType } from 'APIPackage/CatalogsModule/interfaces/IKnmLinkType';
import { IKnmNoticeType } from 'APIPackage/CatalogsModule/interfaces/IKnmNoticeType';
import { IKnmObjectType } from 'APIPackage/CatalogsModule/interfaces/IKnmObjectType';
import { IKnmReasonTypeExtended } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonTypeExtended';
import { IGenericReason } from 'APIPackage/CatalogsModule/interfaces/IGenericReason';
import { IKnmRejectReasonType } from 'APIPackage/CatalogsModule/interfaces/IKnmRejectReasonType';
import { IKnmResultInfoType } from 'APIPackage/CatalogsModule/interfaces/IKnmResultInfoType';
import { IKnmSubjectType } from 'APIPackage/CatalogsModule/interfaces/IKnmSubjectType';
import { IKnmSupervisionType } from 'APIPackage/CatalogsModule/interfaces/IKnmSupervisionType';
import { IKnmType } from 'APIPackage/CatalogsModule/interfaces/IKnmType';
import { IKnmViolationType } from 'APIPackage/CatalogsModule/interfaces/IKnmViolationType';
import { IRiskCategory } from 'APIPackage/CatalogsModule/interfaces/IRiskCategory';
import { ITestPurchaseMethod } from 'APIPackage/CatalogsModule/interfaces/ITestPurchaseMethod';
import { IViolationLawsuitType } from 'APIPackage/CatalogsModule/interfaces/IViolationLawsuitType';
import { fetchChecklistAnswerTypes } from 'APIPackage/CatalogsModule/services/checklistAnswerTypesApi';
import { fetchKnmAddressTypes } from 'APIPackage/CatalogsModule/services/knmAddressTypesApi';
import { fetchKnmDelegateTypes } from 'APIPackage/CatalogsModule/services/knmDelegateTypesApi';
import { fetchKnmDocumentTypes } from 'APIPackage/CatalogsModule/services/knmDocumentTypesApi';
import { fetchKnmExecutionTypes } from 'APIPackage/CatalogsModule/services/knmExecutionTypesApi';
import { fetchErknmKnmExpertTypes } from 'APIPackage/CatalogsModule/services/knmExpertTypesApi';
import { fetchKnmInspectors } from 'APIPackage/KnmModule/services/knmInspectorsApi';
import { fetchKnmPlanReasonChangeTypes } from 'APIPackage/CatalogsModule/services/knmPlanReasonChangeTypesApi';
import { fetchKnmInspectorTypes } from 'APIPackage/CatalogsModule/services/knmInspectorTypesApi';
import { fetchKnmLinkTypes } from 'APIPackage/CatalogsModule/services/knmLinkTypesApi';
import { fetchKnmNoticeMethods } from 'APIPackage/CatalogsModule/services/knmNoticeMethodsApi';
import { fetchKnmObjectTypes } from 'APIPackage/CatalogsModule/services/knmObjectTypesApi';
import {
  fetchGenericReasons,
  fetchKnmReasonTypes,
  fetchErknmKnmErvkConditions,
  fetchPmErvkConditions,
  fetchErpKnmErvkConditions,
  fetchErknmDecisionErvkConditions,
} from 'APIPackage/CatalogsModule/services/knmReasonTypesApi';
import {
  fetchErknmKnmRejectReasonTypes,
  fetchKnmRejectReasonTypes,
} from 'APIPackage/CatalogsModule/services/knmRejectReasonTypesApi';
import { fetchKnmResultInfoTypes } from 'APIPackage/CatalogsModule/services/knmResultInfoTypesApi';
import { fetchKnmSubjectTypes } from 'APIPackage/CatalogsModule/services/knmSubjectTypesApi';
import { fetchKnmResponsibleTypes } from 'APIPackage/CatalogsModule/services/knmResponsibleTypes';
import {
  fetchKnmSupervisionTypes,
  fetchKnmSupervisionTypesByKnmTypeAndSubjectType,
  IFetchKnmSupervisionTypesByKnmTypeAndSubjectType,
} from 'APIPackage/CatalogsModule/services/knmSupervisionTypesApi';
import { fetchResponsibilityTypes } from 'APIPackage/CatalogsModule/services/responsibilityTypesApi';
import { fetchKnmTypes, fetchKnmTypesByKnoAndSupervision } from 'APIPackage/CatalogsModule/services/knmTypesApi';
import { fetchKnmViolationTypes } from 'APIPackage/CatalogsModule/services/knmViolationTypesApi';
import { fetchKnmYears } from 'APIPackage/CatalogsModule/services/yearsApi';
import { fetchRiskCategories } from 'APIPackage/CatalogsModule/services/riskCategoriesApi';
import { fetchTestPurchaseMethods } from 'APIPackage/CatalogsModule/services/testPurchaseMethodsApi';
import { fetchViolationLawsuitTypes } from 'APIPackage/CatalogsModule/services/violationLawsuitTypesApi';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { fetchKnmPlanTypes } from 'APIPackage/CatalogsModule/services/knmPlanTypesApi';
import { IKnmPlanType } from 'APIPackage/CatalogsModule/interfaces/IKnmPlanType';
import { IUserOrganisationsResponse } from 'APIPackage/AccountModule/interfaces/IUserOrganisationsResponse';
import { fetchUserOrganisations } from 'APIPackage/AccountModule/services/userApi';
import { fetchFederalLaws } from 'APIPackage/CatalogsModule/services/federalLawsApi';
import { IFederalLaw } from 'APIPackage/CatalogsModule/interfaces/IFederalLaw';
import { IKnmReasonChangeType } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonChangeType';
import { IKnmResponsibleType } from 'APIPackage/CatalogsModule/interfaces/IKnmResponsibleType';
import { fetchErknmKnmDocumentTypes } from 'APIPackage/CatalogsModule/services/erknmKnmDocumentTypesApi';
import { IAcquaintanceType } from 'APIPackage/CatalogsModule/interfaces/IAcquaintanceType';
import {
  fetchErknmAcquaintanceLackTypes,
  fetchErknmAcquaintanceTypes,
} from 'APIPackage/CatalogsModule/services/acquaintanceTypesApi';
import { IResponsibilityType } from 'APIPackage/CatalogsModule/interfaces/IResponsibilityType';
import { fetchKindResultDecisionCatalog } from 'APIPackage/CatalogsModule/services/kindResultDecisionApi';
import { fetchListTypes } from 'APIPackage/CatalogsModule/services/listTypesApi';
import { IListType } from 'APIPackage/CatalogsModule/interfaces/IListType';
import { fetchMspCategories } from 'APIPackage/CatalogsModule/services/mspCategoriesApi';
import { IMspCategory } from 'APIPackage/CatalogsModule/interfaces/IMspCategory';
import { ITerritorialUnit } from 'APIPackage/CatalogsModule/interfaces/ITerritorialUnit';
import {
  fetchTerritorialUnits,
  fetchTerritorialUnitsByLevelsCountryFederalDistrictRegions,
} from 'APIPackage/CatalogsModule/services/territorialUnitsApi';
import { fetchAnalyticsTerritorialUnits } from 'APIPackage/CatalogsModule/services/analyticsTerritorialUnitsApi';
import { fetchChecklistFullnessTypes } from 'APIPackage/AdminModule/services/adminProsecutorsApi';
import { fetchRegisterTypes } from 'APIPackage/CatalogsModule/services/registerTypesApi';
import { IRegisterType } from 'APIPackage/CatalogsModule/interfaces/IRegisterType';
import { fetchKnmDecisionStatuses, fetchKnmStatuses } from 'APIPackage/CatalogsModule/services/knmStatusesApi';
import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { fetchKnoLevels } from 'APIPackage/CatalogsModule/services/knoOrganisationsApi';
import { getUserRoleIsAdmin } from 'AuthPackage/MainModule/selectors/authSelectors';
import { fetchKnmFormsAll } from 'APIPackage/AdminModule/services/adminKnmFormsApi';
import { IAdminKnmFormResponse } from 'APIPackage/AdminModule/interfaces/IAdminKnmFormResponse';
import { fetchKnmNoticeMethodsAll } from 'APIPackage/AdminModule/services/adminKnmNoticeMethodsApi';
import { fetchKnmSubjectTypesAll } from 'APIPackage/AdminModule/services/adminKnmSubjectTypesApi';
import { fetchKnmTypesAll } from 'APIPackage/AdminModule/services/adminKnmTypesApi';
import { fetchKnmViolationTypesAll } from 'APIPackage/AdminModule/services/adminKnmViolationTypesApi';
import { fetchNewsRoles } from 'APIPackage/AdminModule/services/adminRolesApi';
import { IAdminRolesResponse } from 'APIPackage/AdminModule/interfaces/IAdminRolesResponse';
import { getAccountDefaultKnoOrganizationId } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { IKnmExclusionReason } from 'APIPackage/CatalogsModule/interfaces/IKnmExclusionReason';
import { fetchKnmExclusionReasons } from 'APIPackage/CatalogsModule/services/knmExclusionReasonsApi';
import { coreSetDeepLoading } from 'CorePackage/MainModule/actions/coreActions';
import { IInspectorsResponse } from 'APIPackage/KnmModule/interfaces/IInspectorsResponse';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { fetchKnmCanceledReasons } from 'APIPackage/CatalogsModule/services/knmCanceledReasonsApi';
import { IKnmCanceledReason } from 'APIPackage/CatalogsModule/interfaces/IKnmCanceledReason';
import { fetchCountries } from 'APIPackage/CatalogsModule/services/countriesApi';
import { IViolationMaterialType } from 'APIPackage/CatalogsModule/interfaces/IViolationMaterialType';
import {
  fetchViolationFixGrades,
  fetchViolationFixMethods,
  fetchViolationMaterialTypes,
} from 'APIPackage/CatalogsModule/services/violationFixApi';
import { IViolationFixMethod } from 'APIPackage/CatalogsModule/interfaces/IViolationFixMethod';
import { IViolationFixGrade } from 'APIPackage/CatalogsModule/interfaces/IViolationFixGrade';
import { fetchOrdersAll, fetchOrdersRelationDictionaries } from 'APIPackage/CatalogsModule/services/ordersApi';
import { IOrderRelation } from 'APIPackage/CatalogsModule/interfaces/IOrderRelation';
import {
  dictionariesDangerClassesItemGetSuccess,
  dictionariesEventTypesItemGetSuccess,
  dictionariesKnmKindsItemGetSuccess,
  dictionariesProfKindsItemGetSuccess,
  dictionariesRiskCategoriesItemGetSuccess,
  dictionariesSubjectKindsItemGetSuccess,
  dictionariesSubjectSubKindsItemGetSuccess,
  dictionariesSubjectTypesItemGetSuccess,
  dictionariesTargetEntityItemGetSuccess,
} from 'CorePackage/DictionariesModule/actions/dictionariesActions';
import {
  getKnmErknmKnoOrganizationDictVersionIdFormValue,
  getKnmErknmReasonsFormValue,
  getKnmErknmSupervisionTypeDictVersionIdFormValue,
  getKnmEventUuid,
  getKnmKnoSupervisionUuid,
  getKnmPmReasonsFormValue,
  getKnmSystemType,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { fetchDecisionDocumentTypes } from 'APIPackage/CatalogsModule/services/decisionDocumentTypesApi';
import { fetchPmProfActTypes } from 'APIPackage/CatalogsModule/services/profPmActTypesApi';
import { fetchTerminationReasons } from 'APIPackage/CatalogsModule/services/terminationReasonsApi';
import { ITerminationReason } from 'APIPackage/CatalogsModule/interfaces/ITerminationReason';
import { fetchKnmUavTypes } from 'APIPackage/CatalogsModule/services/knmUavTypesApi';
import { IKnmUavType } from 'APIPackage/CatalogsModule/interfaces/IKnmUavType';

import { IAdminKnmKind } from '../../../APIPackage/AdminModule/interfaces/IAdminKnmKind';
import { fetchKnmKindsAll } from '../../../APIPackage/AdminModule/services/adminKnmKindsApi';
import {
  catalogGet,
  catalogGetFailure,
  catalogGetRequest,
  catalogGetSuccess,
  catalogKnmReasonTypesGet,
  catalogKnmReasonTypesGetFailure,
  catalogKnmReasonTypesGetRequest,
  catalogKnmReasonTypesGetSuccess,
  catalogKnmRejectReasonTypesGet,
  catalogKnmRejectReasonTypesGetFailure,
  catalogKnmRejectReasonTypesGetRequest,
  catalogKnmRejectReasonTypesGetSuccess,
  catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGet,
  catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetRequest,
  catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetSuccess,
  catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetFailure,
  catalogErknmKnmRejectReasonTypesGet,
  catalogErknmKnmRejectReasonTypesGetRequest,
  catalogErknmKnmRejectReasonTypesGetFailure,
  catalogErknmKnmRejectReasonTypesGetSuccess,
  catalogErknmKnmConditionsGetRequest,
  catalogErknmKnmConditionsGetSuccess,
  catalogErknmKnmConditionsGetFailure,
  catalogErknmKnmConditionsGet,
  catalogCreateJudgmentCourt,
  catalogKnmInspectorsGetById,
  catalogPmConditionsGet,
  catalogPmConditionsGetRequest,
  catalogPmConditionsGetSuccess,
  catalogPmConditionsGetFailure,
  catalogOrdersRelationDictionariesGet,
  catalogOrdersRelationDictionariesGetRequest,
  catalogOrdersRelationDictionariesGetSuccess,
  catalogOrdersRelationDictionariesGetFailure,
  catalogKnmTypes248Get,
  catalogKnmTypes248GetFailure,
  catalogKnmTypes248GetRequest,
  catalogKnmTypes248GetSuccess,
  catalogKnoOrganizationWithChildrenRequest,
  catalogKnoOrganizationWithChildrenSuccess,
  catalogKnoOrganizationWithChildrenFailure,
  catalogFnsRegistryOkvedCodesGet,
  catalogFnsRegistryOkvedCodesFailure,
  catalogFnsRegistryOkvedCodesRequest,
  catalogFnsRegistryOkvedCodesSuccess,
  catalogErpKnmConditionsGet,
  catalogErpKnmConditionsGetRequest,
  catalogErpKnmConditionsGetSuccess,
  catalogErpKnmConditionsGetFailure,
  catalogErknmDecisionConditionsGet,
  catalogErknmDecisionConditionsGetRequest,
  catalogErknmDecisionConditionsGetSuccess,
  catalogErknmDecisionConditionsGetFailure,
  catalogForceGet,
  catalogGetErvkObjectsOfControlSelectOptions,
} from '../actions/catalogsActions';
import { CatalogsActionsEnum } from '../enums/CatalogsActionsEnum';
import { CatalogStatusesEnum } from '../enums/CatalogStatusesEnum';
import { CommonCatalogsNamesEnum } from '../enums/CommonCatalogsNamesEnum';
import {
  getCatalogErknmDecisionConditionsStatus,
  getCatalogErknmKnmConditionsStatus,
  getCatalogErknmKnmRejectReasonTypesStatus,
  getCatalogKnmErpConditionsStatus,
  getCatalogKnmReasonTypesStatus,
  getCatalogKnmRejectReasonTypesStatus,
  getCatalogKnmSupervisionTypesByKnmTypeAndSubjectTypeStatus,
  getCatalogKnmTypes248Status,
  getCatalogOrdersRelationDictionaries,
  getCatalogPmConditionsStatus,
  getFnsRegistryOkvedCodesStatus,
  IKnmTypes248Params,
  makeGetCatalogStatus,
} from '../selectors/catalogsSelectors';
import { adminCommonCatalogsNames } from '../constants/adminCommonCatalogsNames';
import { routesToUpdateCatalogs } from '../constants/routesToUpdateCatalogs';
import { sortByWeight } from '../common/sortByWeight';
import { fetchKnmActTypes } from '../../../APIPackage/CatalogsModule/services/knmActTypesApi';
import { IKnmActType } from '../../../APIPackage/CatalogsModule/interfaces/IKnmActType';
import { ICountry } from '../../../APIPackage/CatalogsModule/interfaces/ICountry';
import { IMandatoryCategory } from '../../../APIPackage/CatalogsModule/interfaces/IMandatoryCategory';
import { fetchMandatoryCategories } from '../../../APIPackage/CatalogsModule/services/mandatoryCategoriesApi';
import { IInteractionCategory } from '../../../APIPackage/CatalogsModule/interfaces/IInteractionCategory';
import { fetchInteractionCategories } from '../../../APIPackage/CatalogsModule/services/interactionCategoryApi';
import { IPmFormConducting } from '../../../APIPackage/CatalogsModule/interfaces/IPmFormConducting';
import { fetchPmFormsConducting } from '../../../APIPackage/CatalogsModule/services/pmFormsConductingApi';
import { fetchKnmAccessLevel } from '../../../APIPackage/CatalogsModule/services/knmAccessLevelApi';
import { IKnmAccessLevel } from '../../../APIPackage/CatalogsModule/interfaces/IKnmAccessLevel';
import { IJudgmentCourtLevel } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentCourtLevel';
import { IJudgmentCourt } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentCourt';
import { IJudgmentKind } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentKind';
import { IJudgmentProsecutionType } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentProsecutionType';
import { IJudgmentPunishmentType } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentPunishmentType';
import { IJudgmentPunishmentIndex } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentPunishmentIndex';
import {
  fetchCreateCourt,
  fetchJudgmentCancellationInfo,
  fetchJudgmentCourtLevels,
  fetchJudgmentEnabledCourts,
  fetchJudgmentKinds,
  fetchJudgmentProsecutionTypes,
  fetchJudgmentPunishmentIndex,
  fetchJudgmentPunishmentTypes,
} from '../../../APIPackage/CatalogsModule/services/judgmentApi';
import { fetchFederalDistricts } from '../../../APIPackage/CatalogsModule/services/federalDistrictsApi';
import { IJudgmentCancellationInfo } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentCancellationInfo';
import { IDistrict } from '../../../APIPackage/KnmModule/interfaces/IDistrict';
import { knmSetOrderVersionId, setCreatedJudgmentCourt } from '../../../KnmPackage/MainModule/actions/knmActions';
import { IPmCanceledReason } from '../../../APIPackage/CatalogsModule/interfaces/IPmCanceledReason';
import { fetchPmCanceledReasons } from '../../../APIPackage/CatalogsModule/services/pmCanceledReasonApi';
import { knmReasonsCanceledApi } from '../../../APIPackage/CatalogsModule/services/knmReasonsCanceledApi';
import { knmTypesCancelled } from '../../../APIPackage/CatalogsModule/services/knmTypesCancelled';
import { ISubmittedDocumentsStatusType } from '../../../APIPackage/CatalogsModule/interfaces/ISubmittedDocumentsStatusType';
import { fetchErknmSubmittedDocumentsStatusType } from '../../../APIPackage/CatalogsModule/services/submittedDocumentsStatusTypesApi';
import { IKnmAbrogationReason } from '../../../APIPackage/CatalogsModule/interfaces/IKnmAbrogationReason';
import { KnmSystemTypesEnum } from '../../../KnmPackage/MainModule/enums/KnmSystemTypesEnum';
import {
  fetchDictionaryValues,
  fetchKnoOrganizationWithTerritory,
} from '../../../APIPackage/DictionariesModule/services/dictionariesApi';
import { IUserOrganisation } from '../../../APIPackage/AccountModule/interfaces/IUserOrganisation';
import {
  getPlanDataKnoOrganizationDictVersionId,
  getPlanDataSupervisionDictVersionId,
} from '../../../PlanPackage/MainModule/selectors/planSelectors';
import { fetchFnsRegistrySearchOkved } from '../../../APIPackage/FnsModule/services/fnsRegistryApi';
import { accountOrganizationsWithDistrictGetSuccess } from '../../AccountModule/actions/accountActions';
import { fetchProsecutorOrganizationsApi } from '../../../APIPackage/CatalogsModule/services/prosecutorOrganizationsApi';
import { IProsecutorOrganizations } from '../../../APIPackage/CatalogsModule/interfaces/IProsecutorOrganizations';
import { IKnoLevel } from '../../../APIPackage/CatalogsModule/interfaces/IKnoLevel';
import { IKnmRemark } from '../../../APIPackage/CatalogsModule/interfaces/IKnmRemark';
import { fetchKnmRemarks, fetchKnmRemarksAll } from '../../../APIPackage/CatalogsModule/services/knmRemarkApi';
import { IPassportMassCancelReason } from '../../../APIPackage/CatalogsModule/interfaces/IPassportMassCancelReason';
import { fetchPassportMassCancelReasons } from '../../../APIPackage/CatalogsModule/services/passportMassCancelReasonApi';
import { fetchPassportMassDeleteReasons } from '../../../APIPackage/CatalogsModule/services/passportMassDeleteReasonApi';
import { IKnmOrder } from '../../../APIPackage/KnmModule/interfaces/IKnmOrder';
import { IErvkObjectsOfControl } from '../../../APIPackage/KnmModule/interfaces/IErvkObjectsOfControl';
import { findErvkObjectsOfControl } from '../../../APIPackage/KnmModule/services/knmErvkObjectsOfControlApi';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { DictionaryUUIDsEnum } from '../../DictionariesModule/enums/DictionaryUUIDsEnum';
import { IKnoLevelErvk } from '../../../APIPackage/CatalogsModule/interfaces/IKnoLevelErvk';
import { fetchAgreementChangeReason } from '../../../APIPackage/CatalogsModule/services/argeementChangeReason';
import { IAgreementChangeReasonInterface } from '../../../APIPackage/CatalogsModule/interfaces/IAgreementChangeReason';

export function* watchCatalogSaga() {
  yield takeEvery(CatalogsActionsEnum.CATALOG_GET, catalogGetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_FORCE_GET, catalogForceGetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET, catalogKnmReasonTypesGetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET, catalogKnmRejectReasonTypesGetHandler);
  yield takeEvery(
    CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET,
    catalogErknmKnmRejectReasonTypesGetHandler,
  );
  yield takeEvery(CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET, catalogErknmKnmConditionsGetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET, catalogPmConditionsGetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET, catalogErpKnmConditionsGetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET, catalogErknmDecisionConditionsGetHandler);
  yield takeEvery(
    CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET,
    catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetHandler,
  );
  yield takeEvery(CatalogsActionsEnum.CATALOG_KNM_INSPECTORS_GET_BY_ID, fetchKnmInspectorsSaga);
  yield takeEvery(CatalogsActionsEnum.JUDGMENT_CREATE_COURT, fetchCreateJudgmentCourt);
  yield takeEvery(
    CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET,
    catalogOrdersRelationDictionariesGetHandler,
  );
  yield takeEvery(CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET, catalogsKnmTypes248GetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET, knoOrganizationWithChildrenGetSaga);
  yield takeEvery(CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_GET, catalogsFnsRegistryOkvedCodesGetHandler);
  yield takeEvery(CatalogsActionsEnum.CATALOG_ERKNM_KNO_LEVELS_GET, fetchKnoLevelsSaga);
  yield takeEvery(
    CatalogsActionsEnum.CATALOG_GET_ERVK_OBJECTS_OF_CONTROL_SELECT_OPTIONS,
    catalogGetErvkObjectsOfControlSelectOptionsSaga,
  );
}

const fetchMap: Record<CommonCatalogsNamesEnum, () => void> = {
  [CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES]: fetchChecklistAnswerTypesSaga,
  [CommonCatalogsNamesEnum.ERKNM_KNM_EXPERT_TYPES]: fetchErknmKnmExpertTypesSaga,
  [CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES]: fetchKnmAddressTypesSaga,
  [CommonCatalogsNamesEnum.KNM_REASONS_CANCELED]: fetchKnmReasonsCanceledSaga,
  [CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES]: fetchKnmDelegateTypesSaga,
  [CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES]: fetchKnmDocumentTypesSaga,
  [CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES]: fetchErknmKnmDocumentTypesSaga,
  [CommonCatalogsNamesEnum.DECISION_DOCUMENT_TYPES]: fetchDecisionDocumentTypesSaga,
  [CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES]: fetchKnmExecutionTypesSaga,
  [CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES_ALL]: fetchKnmExecutionTypesAllSaga,
  [CommonCatalogsNamesEnum.ROLES]: fetchRolesSaga,
  [CommonCatalogsNamesEnum.KNM_INSPECTORS]: fetchKnmInspectorsSaga,
  [CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES]: fetchKnmInspectorTypesSaga,
  [CommonCatalogsNamesEnum.KNM_LINK_TYPES]: fetchKnmLinkTypesSaga,
  [CommonCatalogsNamesEnum.KNM_NOTICE_METHODS]: fetchKnmNoticeMethodsSaga,
  [CommonCatalogsNamesEnum.KNM_NOTICE_METHODS_ALL]: fetchKnmNoticeMethodsAllSaga,
  [CommonCatalogsNamesEnum.KNM_OBJECT_TYPES]: fetchKnmObjectTypesSaga,
  [CommonCatalogsNamesEnum.LIST_TYPES]: fetchListTypesSaga,
  [CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS]: fetchKnoAdminLevelsSaga,
  [CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES]: fetchKnmResultInfoTypesSaga,
  [CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES]: fetchKnmSubjectTypesSaga,
  [CommonCatalogsNamesEnum.KNM_RESPONSIBLE_TYPES]: fetchKnmResponsibleTypesSaga,
  [CommonCatalogsNamesEnum.KNM_TYPES_294]: fetchKnmTypes294Saga,
  [CommonCatalogsNamesEnum.KNM_STATUSES_248]: fetchKnmStatuses248Saga,
  [CommonCatalogsNamesEnum.KNM_STATUSES_294]: fetchKnmStatuses294Saga,
  [CommonCatalogsNamesEnum.PM_STATUSES]: fetchPmStatusesSaga,
  [CommonCatalogsNamesEnum.DECISION_STATUSES]: fetchDecisionStatusesSaga,
  [CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL]: fetchKnmSubjectTypesAllSaga,
  [CommonCatalogsNamesEnum.KNM_TYPES_CANCELED]: fetchKnmTypesCancelled,
  [CommonCatalogsNamesEnum.KNM_TYPES_ALL]: fetchKnmTypesAllSaga,
  [CommonCatalogsNamesEnum.KNM_KINDS_ALL]: fetchKnmKindsAllSaga,
  [CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES]: fetchKnmViolationTypesSaga,
  [CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL]: fetchKnmViolationTypesAllSaga,
  [CommonCatalogsNamesEnum.KNM_YEARS]: fetchKnmYearsSaga,
  [CommonCatalogsNamesEnum.RISK_CATEGORIES]: fetchRiskCategoriesSaga,
  [CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS]: fetchTestPurchaseMethodsSaga,
  [CommonCatalogsNamesEnum.VIOLATION_LAWSUIT_TYPES]: fetchViolationLawsuitTypesSaga,
  [CommonCatalogsNamesEnum.KNM_PLAN_TYPES]: fetchKnmPlanTypesSaga,
  [CommonCatalogsNamesEnum.USER_KNOS]: fetchUserOrganisationsSaga,
  [CommonCatalogsNamesEnum.USER_PROSECUTORS]: fetchUserOrganisationsSaga,
  [CommonCatalogsNamesEnum.FEDERAL_LAWS_248]: fetchFederalLaws248Saga,
  [CommonCatalogsNamesEnum.FEDERAL_LAWS_294]: fetchFederalLaws294Saga,
  [CommonCatalogsNamesEnum.SUPERVISION_TYPES]: fetchSupervisionTypesSaga,
  [CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES]: fetchChecklistFullnessTypesSaga,
  [CommonCatalogsNamesEnum.REGISTER_TYPES]: fetchRegisterTypesSaga,
  [CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES]: fetchResponsibilityTypesSaga,
  [CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES]: fetchKnmPlanReasonChangeTypesSaga,
  [CommonCatalogsNamesEnum.KNM_EXCLUSION_REASONS]: fetchKnmExclusionReasonsSaga,
  [CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES]: fetchErknmAcquaintanceTypesSaga,
  [CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES]: fetchErknmAcquaintanceLackTypesSaga,
  [CommonCatalogsNamesEnum.ERKNM_SUBMITTED_DOCUMENTS_STATUS]: fetchErknmSubmittedDocumentsTypesSaga,
  [CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION]: fetchErknmKindResultDecisionSaga,
  [CommonCatalogsNamesEnum.MSP_CATEGORIES]: fetchMspCategoriesSaga,
  [CommonCatalogsNamesEnum.TERRITORIAL_UNITS]: fetchTerritorialUnitsSaga,
  [CommonCatalogsNamesEnum.TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS]: fetchTerritorialUnitsByLevelsCountryFederalDistrictRegionsSaga,
  [CommonCatalogsNamesEnum.PROSECUTOR_ORGANIZATIONS]: fetchProsecutorOrganizationsSaga,
  [CommonCatalogsNamesEnum.ANALYTICS_TERRITORIAL_UNITS]: fetchAnalyticsTerritorialUnitsSaga,
  [CommonCatalogsNamesEnum.KNM_ACT_TYPES]: fetchKnmActTypesSaga,
  [CommonCatalogsNamesEnum.PM_PROF_ACT_TYPES]: fetchPmProfActTypesSaga,
  [CommonCatalogsNamesEnum.KNM_CANCELED_REASONS]: fetchKnmCanceledReasonsSaga,
  [CommonCatalogsNamesEnum.MANDATORY_CATEGORIES]: fetchMandatoryCategoriesSaga,
  [CommonCatalogsNamesEnum.COUNTRIES]: fetchCountriesSaga,
  [CommonCatalogsNamesEnum.GENERIC_REASONS]: fetchGenericReasonsSaga,
  [CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS]: fetchDecisionGenericReasonsSaga,
  [CommonCatalogsNamesEnum.INTERACTION_CATEGORIES]: fetchInteractionCategoriesSaga,
  [CommonCatalogsNamesEnum.PM_FORMS_CONDUCTING]: fetchPmFormsConductingSaga,
  [CommonCatalogsNamesEnum.JUDGMENT_COURT_LEVELS]: fetchJudgmentCourtLevelsSaga,
  [CommonCatalogsNamesEnum.JUDGMENT_COURTS]: fetchJudgmentCourts,
  [CommonCatalogsNamesEnum.JUDGMENT_KINDS]: fetchJudgmentKindsSaga,
  [CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES]: fetchJudgmentProsecutionTypesSaga,
  [CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES]: fetchJudgmentPunishmentTypesSaga,
  [CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_INDEX]: fetchJudgmentPunishmentIndexSaga,
  [CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION]: fetchJudgmentCancellationInformationTypesSaga,
  [CommonCatalogsNamesEnum.DISTRICTS]: fetchDistrictsSaga,
  [CommonCatalogsNamesEnum.KNM_ACCESS_LEVELS]: fetchKnmAccessLevelsSaga,
  [CommonCatalogsNamesEnum.PM_CANCELED_REASONS]: fetchPmCanceledReasonsSaga,
  [CommonCatalogsNamesEnum.VIOLATION_MATERIAL_TYPE]: fetchViolationMaterialTypesSaga,
  [CommonCatalogsNamesEnum.VIOLATION_FIX_METHOD]: fetchViolationFixMethodsSaga,
  [CommonCatalogsNamesEnum.VIOLATION_FIX_GRADE]: fetchViolationFixGradesSaga,
  [CommonCatalogsNamesEnum.KNO_LEVELS]: fetchKnoLevelsSaga,
  [CommonCatalogsNamesEnum.KNM_REMARKS]: fetchKnmRemarksSaga,
  [CommonCatalogsNamesEnum.KNM_REMARKS_ALL]: fetchKnmRemarksAllSaga,
  [CommonCatalogsNamesEnum.PASSPORT_MASS_CANCEL_REASON]: fetchPassportMassCancelReasonSaga,
  [CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON]: fetchPassportMassDeleteReasonSaga,
  [CommonCatalogsNamesEnum.ERVK_ORDERS]: fetchErvkOrdersSaga,
  [CommonCatalogsNamesEnum.AGREEMENT_CHANGE_REASON]: fetchAgreementChangeReasonSaga,
  [CommonCatalogsNamesEnum.TERMINATION_REASONS]: fetchTerminationReasonsSaga,
  [CommonCatalogsNamesEnum.UAV_TYPES]: fetchKnmUavTypesSaga,
};

function* catalogGetHandler(action: ActionType<typeof catalogGet>) {
  const { catalogName, isDeepLoading } = action.payload;

  const state: IRootState = yield select();
  const isAdmin = getUserRoleIsAdmin(state);
  const catalogStatus = makeGetCatalogStatus(catalogName)(state);
  const routeWithUpdate = routesToUpdateCatalogs[window.location.pathname];

  if (
    (routeWithUpdate && routeWithUpdate.includes(catalogName)) ||
    (isAdmin && adminCommonCatalogsNames.includes(catalogName)) ||
    catalogStatus === CatalogStatusesEnum.IDLE
  ) {
    if (isDeepLoading) {
      yield put(coreSetDeepLoading(true));
    }

    yield fetchMap[catalogName]();
  }

  if (isDeepLoading) {
    yield put(coreSetDeepLoading(false));
  }
}

function* catalogForceGetHandler(action: ActionType<typeof catalogForceGet>) {
  const { catalogName, isDeepLoading } = action.payload;

  if (isDeepLoading) {
    yield put(coreSetDeepLoading(true));
  }

  yield fetchMap[catalogName]();

  if (isDeepLoading) {
    yield put(coreSetDeepLoading(false));
  }
}

function* catalogKnmReasonTypesGetHandler(action: ActionType<typeof catalogKnmReasonTypesGet>) {
  const { knmTypeId, isErp } = action.payload;
  const catalogStatus: CatalogStatusesEnum = yield select(getCatalogKnmReasonTypesStatus, knmTypeId);

  if (isErp && (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE)) {
    yield fetchKnmReasonTypesSaga(knmTypeId);
  }
}

function* catalogKnmRejectReasonTypesGetHandler(action: ActionType<typeof catalogKnmRejectReasonTypesGet>) {
  const { knmTypeId } = action.payload;

  const catalogStatus: CatalogStatusesEnum = yield select(getCatalogKnmRejectReasonTypesStatus, knmTypeId);

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchKnmRejectReasonTypesSaga(knmTypeId);
  }
}

function* catalogErknmKnmRejectReasonTypesGetHandler(action: ActionType<typeof catalogErknmKnmRejectReasonTypesGet>) {
  const { isPlaned } = action.payload;

  const catalogStatus: CatalogStatusesEnum = yield select(getCatalogErknmKnmRejectReasonTypesStatus, isPlaned);

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchErknmKnmRejectReasonTypesSaga(isPlaned);
  }
}

function* catalogErknmKnmConditionsGetHandler(action: ActionType<typeof catalogErknmKnmConditionsGet>) {
  const { knoOrganizationDictVersionId, supervisionTypeDictVersionId, erknmTypeCode, knmKindId } = action.payload;

  const catalogStatus: CatalogStatusesEnum = yield select(
    getCatalogErknmKnmConditionsStatus,
    knoOrganizationDictVersionId,
    supervisionTypeDictVersionId,
    erknmTypeCode,
    knmKindId,
  );

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchErknmKnmConditionsSaga(
      knoOrganizationDictVersionId,
      supervisionTypeDictVersionId,
      erknmTypeCode,
      knmKindId,
    );
  }
}

function* catalogPmConditionsGetHandler(action: ActionType<typeof catalogPmConditionsGet>) {
  const { knoOrganizationDictVersionId, supervisionTypeDictVersionId, profKindId, uuidFederalLaw } = action.payload;

  const catalogStatus: CatalogStatusesEnum = yield select(
    getCatalogPmConditionsStatus,
    knoOrganizationDictVersionId,
    supervisionTypeDictVersionId,
    profKindId,
    uuidFederalLaw,
  );

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchPmConditionsSaga(knoOrganizationDictVersionId, supervisionTypeDictVersionId, profKindId, uuidFederalLaw);
  }
}

function* catalogErpKnmConditionsGetHandler(action: ActionType<typeof catalogErpKnmConditionsGet>) {
  const { knoOrganizationId, supervisionTypeId, knmTypeCode, federalLaw, knmKindId } = action.payload;

  const catalogStatus: CatalogStatusesEnum = yield select(
    getCatalogKnmErpConditionsStatus,
    knoOrganizationId,
    supervisionTypeId,
    knmTypeCode,
    knmKindId,
  );

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchErpKnmConditionsSaga(knoOrganizationId, supervisionTypeId, knmTypeCode, federalLaw, knmKindId);
  }
}

function* catalogErknmDecisionConditionsGetHandler(action: ActionType<typeof catalogErknmDecisionConditionsGet>) {
  const { knoOrganizationDictVersionId, supervisionTypeDictVersionId, decisionKindId } = action.payload;

  const catalogStatus: CatalogStatusesEnum = yield select(
    getCatalogErknmDecisionConditionsStatus,
    knoOrganizationDictVersionId,
    supervisionTypeDictVersionId,
    decisionKindId,
  );

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchErknmDecisionConditionsSaga(knoOrganizationDictVersionId, supervisionTypeDictVersionId, decisionKindId);
  }
}

function* catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetHandler(
  action: ActionType<typeof catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGet>,
) {
  const { params } = action.payload;
  const catalogStatus: CatalogStatusesEnum = yield select(
    getCatalogKnmSupervisionTypesByKnmTypeAndSubjectTypeStatus,
    params,
  );

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchKnmSupervisionTypesByKnmTypeAndSubjectTypeSaga(params);
  }
}

function* fetchChecklistAnswerTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES));
    const checklistAnswerTypes: IChecklistAnswerType[] = yield fetchChecklistAnswerTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES, checklistAnswerTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmKnmExpertTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ERKNM_KNM_EXPERT_TYPES));
    const knmExpertTypes: IKnmExpertType[] = yield fetchErknmKnmExpertTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ERKNM_KNM_EXPERT_TYPES, knmExpertTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ERKNM_KNM_EXPERT_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmPlanReasonChangeTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES));
    const knmPlanReasonChangeTypes: IKnmReasonChangeType[] = yield fetchKnmPlanReasonChangeTypes();

    yield put(
      catalogGetSuccess(CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES, sortByWeight(knmPlanReasonChangeTypes)),
    );
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchAgreementChangeReasonSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.AGREEMENT_CHANGE_REASON));
    const agreementChangeReason: IAgreementChangeReasonInterface[] = yield fetchAgreementChangeReason();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.AGREEMENT_CHANGE_REASON, sortByWeight(agreementChangeReason)));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.AGREEMENT_CHANGE_REASON));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmExclusionReasonsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_EXCLUSION_REASONS));
    const knmExclusionReasons: IKnmExclusionReason[] = yield fetchKnmExclusionReasons();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_EXCLUSION_REASONS, sortByWeight(knmExclusionReasons)));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_EXCLUSION_REASONS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmKnmConditionsSaga(
  knoVersionId: string,
  supervisionVersionId: string,
  erknmTypeCode: string,
  knmKindId: string | undefined,
) {
  function* funcTry() {
    yield put(catalogErknmKnmConditionsGetRequest(knoVersionId, supervisionVersionId, erknmTypeCode, knmKindId));

    const knmReasonTypes: IKnmReasonTypeExtended[] = yield fetchErknmKnmErvkConditions(
      knoVersionId,
      supervisionVersionId,
      erknmTypeCode,
      knmKindId,
    );

    yield put(
      catalogErknmKnmConditionsGetSuccess(knoVersionId, supervisionVersionId, erknmTypeCode, knmKindId, knmReasonTypes),
    );
  }
  function* funcCatch() {
    yield put(catalogErknmKnmConditionsGetFailure(knoVersionId, supervisionVersionId, erknmTypeCode, knmKindId));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchPmConditionsSaga(
  knoVersionId: string,
  supervisionVersionId: string,
  profKindId?: string,
  uuidFederalLaw?: string,
) {
  function* funcTry() {
    yield put(catalogPmConditionsGetRequest(knoVersionId, supervisionVersionId, profKindId));

    const knmReasonTypes: IKnmReasonTypeExtended[] = yield fetchPmErvkConditions(
      knoVersionId,
      supervisionVersionId,
      profKindId,
      uuidFederalLaw,
    );

    yield put(
      catalogPmConditionsGetSuccess(knoVersionId, supervisionVersionId, profKindId, knmReasonTypes, uuidFederalLaw),
    );
  }
  function* funcCatch() {
    yield put(catalogPmConditionsGetFailure(knoVersionId, supervisionVersionId, profKindId));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErpKnmConditionsSaga(
  knoVersionId: string,
  supervisionVersionId: string,
  knmTypeCode: string,
  federalLaw: string,
  knmKindId: string | undefined,
) {
  function* funcTry() {
    yield put(
      catalogErpKnmConditionsGetRequest(knoVersionId, supervisionVersionId, knmTypeCode, federalLaw, knmKindId),
    );

    const knmReasonTypes: IKnmReasonTypeExtended[] = yield fetchErpKnmErvkConditions(
      knoVersionId,
      supervisionVersionId,
      knmTypeCode,
      federalLaw,
      knmKindId,
    );

    yield put(
      catalogErpKnmConditionsGetSuccess(
        knoVersionId,
        supervisionVersionId,
        knmTypeCode,
        federalLaw,
        knmKindId,
        knmReasonTypes,
      ),
    );
  }
  function* funcCatch() {
    yield put(
      catalogErpKnmConditionsGetFailure(knoVersionId, supervisionVersionId, knmTypeCode, federalLaw, knmKindId),
    );
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmDecisionConditionsSaga(knoVersionId: string, supervisionVersionId: string, decisionKindId: string) {
  function* funcTry() {
    yield put(catalogErknmDecisionConditionsGetRequest(knoVersionId, supervisionVersionId, decisionKindId));

    const decisionReasonTypes: IKnmReasonTypeExtended[] = yield fetchErknmDecisionErvkConditions(
      knoVersionId,
      supervisionVersionId,
      decisionKindId,
    );

    yield put(
      catalogErknmDecisionConditionsGetSuccess(knoVersionId, supervisionVersionId, decisionKindId, decisionReasonTypes),
    );
  }
  function* funcCatch() {
    yield put(catalogErknmDecisionConditionsGetFailure(knoVersionId, supervisionVersionId, decisionKindId));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchResponsibilityTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES));
    const responsibilityTypes: IResponsibilityType[] = yield fetchResponsibilityTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES, responsibilityTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmAddressTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES));
    const knmAddressTypes: IKnmAddressType[] = yield fetchKnmAddressTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES, knmAddressTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmReasonsCanceledSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_REASONS_CANCELED));
    const knmReasonsCancelled: IKnmAddressType[] = yield knmReasonsCanceledApi();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_REASONS_CANCELED, knmReasonsCancelled));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_REASONS_CANCELED));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmDelegateTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES));
    const knmDelegateTypes: IKnmDelegateType[] = yield fetchKnmDelegateTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES, knmDelegateTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmDocumentTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES));
    const knmDocumentTypes: IKnmDocumentType[] = yield fetchKnmDocumentTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES, knmDocumentTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmKnmDocumentTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES));
    const erknmKnmDocumentTypes: IKnmDocumentType[] = yield fetchErknmKnmDocumentTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES, erknmKnmDocumentTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}
function* fetchDecisionDocumentTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.DECISION_DOCUMENT_TYPES));
    const decisionDocumentTypes: IKnmDocumentType[] = yield fetchDecisionDocumentTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.DECISION_DOCUMENT_TYPES, decisionDocumentTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.DECISION_DOCUMENT_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmExecutionTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES));
    const knmExecutionTypes: IKnmExecutionType[] = yield fetchKnmExecutionTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES, knmExecutionTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmExecutionTypesAllSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES_ALL));
    const knmExecutionTypes: IAdminKnmFormResponse[] = yield fetchKnmFormsAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES_ALL, knmExecutionTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES_ALL));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchRolesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ROLES));
    const roles: IAdminRolesResponse = yield fetchNewsRoles();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ROLES, roles.list));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ROLES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmInspectorsSaga(action?: ActionType<typeof catalogKnmInspectorsGetById>) {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_INSPECTORS));
    const knoId: string | undefined = yield select(getAccountDefaultKnoOrganizationId);
    const knmInspectors: IInspectorsResponse = yield fetchKnmInspectors(action?.payload?.id || knoId);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_INSPECTORS, knmInspectors.inspectors));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_INSPECTORS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmInspectorTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES));
    const knmInspectorTypes: IKnmInspectorType[] = yield fetchKnmInspectorTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES, knmInspectorTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmLinkTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_LINK_TYPES));
    const knmLinkTypes: IKnmLinkType[] = yield fetchKnmLinkTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_LINK_TYPES, knmLinkTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_LINK_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmNoticeMethodsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_NOTICE_METHODS));
    const knmNoticeMethods: IKnmNoticeType[] = yield fetchKnmNoticeMethods();
    const knmNoticeMethodsWithRenamedEPGU = knmNoticeMethods.map(nm =>
      nm.name === 'ЕПГУ' ? { ...nm, name: 'портал Госуслуги' } : nm,
    );

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_NOTICE_METHODS, knmNoticeMethodsWithRenamedEPGU));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_NOTICE_METHODS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmNoticeMethodsAllSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_NOTICE_METHODS_ALL));
    const knmNoticeMethods: IKnmNoticeType[] = yield fetchKnmNoticeMethodsAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_NOTICE_METHODS_ALL, knmNoticeMethods));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_NOTICE_METHODS_ALL));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmObjectTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_OBJECT_TYPES));
    const knmObjectTypes: IKnmObjectType[] = yield fetchKnmObjectTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_OBJECT_TYPES, knmObjectTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_OBJECT_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchListTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.LIST_TYPES));
    const listTypes: IListType[] = yield fetchListTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.LIST_TYPES, listTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.LIST_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnoAdminLevelsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS));

    const rawData: { id: number; value: string }[] = yield fetchDictionaryValues(DictionaryUUIDsEnum.KNO_LEVELS, -1);

    let parsedData = rawData.map(item => JSON.parse(item.value) as IKnoLevelErvk);

    parsedData = parsedData.sort((a, b) => {
      return a.code.localeCompare(b.code);
    });

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS, parsedData));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS));
  }

  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmReasonTypesSaga(knmTypeId: number) {
  function* funcTry() {
    yield put(catalogKnmReasonTypesGetRequest(knmTypeId));
    const knmReasonTypes: IKnmReasonTypeExtended[] = yield fetchKnmReasonTypes(knmTypeId);

    yield put(catalogKnmReasonTypesGetSuccess(knmTypeId, knmReasonTypes));
  }
  function* funcCatch() {
    yield put(catalogKnmReasonTypesGetFailure(knmTypeId));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmRejectReasonTypesSaga(knmTypeId: number) {
  function* funcTry() {
    yield put(catalogKnmRejectReasonTypesGetRequest(knmTypeId));
    const knmRejectReasonTypes: IKnmRejectReasonType[] = yield fetchKnmRejectReasonTypes(knmTypeId);

    yield put(catalogKnmRejectReasonTypesGetSuccess(knmTypeId, knmRejectReasonTypes));
  }
  function* funcCatch() {
    yield put(catalogKnmRejectReasonTypesGetFailure(knmTypeId));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmKnmRejectReasonTypesSaga(isPlaned: boolean) {
  function* funcTry() {
    yield put(catalogErknmKnmRejectReasonTypesGetRequest(isPlaned));
    const knmRejectReasonTypes: IKnmRejectReasonType[] = yield fetchErknmKnmRejectReasonTypes(isPlaned);

    yield put(catalogErknmKnmRejectReasonTypesGetSuccess(isPlaned, knmRejectReasonTypes));
  }
  function* funcCatch() {
    yield put(catalogErknmKnmRejectReasonTypesGetFailure(isPlaned));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmResultInfoTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES));
    const knmResultInfoTypes: IKnmResultInfoType[] = yield fetchKnmResultInfoTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES, knmResultInfoTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmSubjectTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES));
    const knmSubjectTypes: IKnmSubjectType[] = yield fetchKnmSubjectTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES, knmSubjectTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmSubjectTypesAllSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL));
    const knmSubjectTypes: IKnmSubjectType[] = yield fetchKnmSubjectTypesAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL, knmSubjectTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmResponsibleTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_RESPONSIBLE_TYPES));
    const knmResponsibleTypes: IKnmResponsibleType[] = yield fetchKnmResponsibleTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_RESPONSIBLE_TYPES, knmResponsibleTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_RESPONSIBLE_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmSupervisionTypesByKnmTypeAndSubjectTypeSaga(
  params: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType,
) {
  function* funcTry() {
    yield put(catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetRequest(params));
    const knmSupervisionTypes: IKnmSupervisionType[] = yield fetchKnmSupervisionTypesByKnmTypeAndSubjectType(params);

    yield put(catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetSuccess(params, knmSupervisionTypes));
  }
  function* funcCatch() {
    yield put(catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetFailure(params));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmTypesCancelled() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_TYPES_CANCELED));
    const knmTypes: IKnmAbrogationReason[] = yield knmTypesCancelled();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_TYPES_CANCELED, knmTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_TYPES_CANCELED));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmTypes294Saga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_TYPES_294));
    const knmTypes: IKnmType[] = yield fetchKnmTypes(false);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_TYPES_294, knmTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_TYPES_294));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmStatuses248Saga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_STATUSES_248));
    const knmStatuses: IKnmStatus[] = yield fetchKnmStatuses(true);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_STATUSES_248, knmStatuses));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_STATUSES_248));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmStatuses294Saga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_STATUSES_294));
    const knmStatuses: IKnmStatus[] = yield fetchKnmStatuses(false);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_STATUSES_294, knmStatuses));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_STATUSES_294));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchPmStatusesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.PM_STATUSES));
    const pmStatuses: IKnmStatus[] = yield fetchKnmStatuses(true, true);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.PM_STATUSES, pmStatuses));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.PM_STATUSES));
  }
  yield sagaWrapper({ funcTry, funcCatch });
}

function* fetchDecisionStatusesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.DECISION_STATUSES));
    const decisionStatuses: IKnmStatus[] = yield fetchKnmDecisionStatuses();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.DECISION_STATUSES, decisionStatuses));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.DECISION_STATUSES));
  }
  yield sagaWrapper({ funcTry, funcCatch });
}

function* fetchKnmTypesAllSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_TYPES_ALL));
    const knmTypes: IKnmType[] = yield fetchKnmTypesAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_TYPES_ALL, knmTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_TYPES_ALL));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

/**
 * Получение списка всех видов КНМ для админки
 */
function* fetchKnmKindsAllSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_KINDS_ALL));
    const knmKinds: IAdminKnmKind[] = yield fetchKnmKindsAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_KINDS_ALL, knmKinds));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_KINDS_ALL));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmViolationTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES));
    const knmViolationTypes: IKnmViolationType[] = yield fetchKnmViolationTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES, knmViolationTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmViolationTypesAllSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL));
    const knmViolationTypes: IKnmViolationType[] = yield fetchKnmViolationTypesAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL, knmViolationTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmYearsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_YEARS));
    const years: number[] = yield fetchKnmYears();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_YEARS, years));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_YEARS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchTestPurchaseMethodsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS));
    const testPurchaseMethods: ITestPurchaseMethod[] = yield fetchTestPurchaseMethods();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS, testPurchaseMethods));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchRiskCategoriesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.RISK_CATEGORIES));
    const riskCategories: IRiskCategory[] = yield fetchRiskCategories();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.RISK_CATEGORIES, riskCategories));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.RISK_CATEGORIES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchViolationLawsuitTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.VIOLATION_LAWSUIT_TYPES));
    const violationLawsuitTypes: IViolationLawsuitType[] = yield fetchViolationLawsuitTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.VIOLATION_LAWSUIT_TYPES, violationLawsuitTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.VIOLATION_LAWSUIT_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmPlanTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_PLAN_TYPES));
    const planTypes: IKnmPlanType[] = yield fetchKnmPlanTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_PLAN_TYPES, planTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_PLAN_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchUserOrganisationsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.USER_KNOS));
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.USER_PROSECUTORS));
    const orgs: IUserOrganisationsResponse = yield fetchUserOrganisations();
    const { KNO, PROSECUTOR } = orgs;

    yield put(accountOrganizationsWithDistrictGetSuccess(orgs));
    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.USER_KNOS, KNO));
    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.USER_PROSECUTORS, PROSECUTOR));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.USER_KNOS));
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.USER_PROSECUTORS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchFederalLaws248Saga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.FEDERAL_LAWS_248));
    const federalLaws: IFederalLaw[] = yield fetchFederalLaws(true);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.FEDERAL_LAWS_248, federalLaws));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.FEDERAL_LAWS_248));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchFederalLaws294Saga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.FEDERAL_LAWS_294));
    const federalLaws: IFederalLaw[] = yield fetchFederalLaws(false);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.FEDERAL_LAWS_294, federalLaws));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.FEDERAL_LAWS_294));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSupervisionTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.SUPERVISION_TYPES));
    const supervisionTypes: IKnmSupervisionType[] = yield fetchKnmSupervisionTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.SUPERVISION_TYPES, supervisionTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.SUPERVISION_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchChecklistFullnessTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES));
    const checklistFullnessTypes: IKnmSupervisionType[] = yield fetchChecklistFullnessTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES, checklistFullnessTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchRegisterTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.REGISTER_TYPES));
    const registerTypes: IRegisterType[] = yield fetchRegisterTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.REGISTER_TYPES, registerTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.REGISTER_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmAcquaintanceTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES));
    const acquaintanceTypes: IAcquaintanceType[] = yield fetchErknmAcquaintanceTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES, acquaintanceTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmAcquaintanceLackTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES));
    const acquaintanceTypes: IAcquaintanceType[] = yield fetchErknmAcquaintanceLackTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES, acquaintanceTypes));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmSubmittedDocumentsTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ERKNM_SUBMITTED_DOCUMENTS_STATUS));
    const types: ISubmittedDocumentsStatusType[] = yield fetchErknmSubmittedDocumentsStatusType();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ERKNM_SUBMITTED_DOCUMENTS_STATUS, types));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ERKNM_SUBMITTED_DOCUMENTS_STATUS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchErknmKindResultDecisionSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION));
    const erknmKindResultDecision: IKnmObjectType[] = yield fetchKindResultDecisionCatalog();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION, erknmKindResultDecision));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchMspCategoriesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.MSP_CATEGORIES));
    const mspCategories: IMspCategory[] = yield fetchMspCategories();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.MSP_CATEGORIES, mspCategories));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.MSP_CATEGORIES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchTerritorialUnitsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.TERRITORIAL_UNITS));
    const territorialUnits: ITerritorialUnit[] = yield fetchTerritorialUnits();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.TERRITORIAL_UNITS, territorialUnits));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.TERRITORIAL_UNITS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchTerritorialUnitsByLevelsCountryFederalDistrictRegionsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS));
    const territorialUnits: ITerritorialUnit[] = yield fetchTerritorialUnitsByLevelsCountryFederalDistrictRegions();

    yield put(
      catalogGetSuccess(
        CommonCatalogsNamesEnum.TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS,
        territorialUnits,
      ),
    );
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchProsecutorOrganizationsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.PROSECUTOR_ORGANIZATIONS));
    const territorialUnits: IProsecutorOrganizations[] = yield fetchProsecutorOrganizationsApi();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.PROSECUTOR_ORGANIZATIONS, territorialUnits));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.PROSECUTOR_ORGANIZATIONS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchAnalyticsTerritorialUnitsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.ANALYTICS_TERRITORIAL_UNITS));
    const analyticsTerritorialUnits: ITerritorialUnit[] = yield fetchAnalyticsTerritorialUnits();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ANALYTICS_TERRITORIAL_UNITS, analyticsTerritorialUnits));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ANALYTICS_TERRITORIAL_UNITS));
  }

  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmActTypesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_ACT_TYPES));
  try {
    const knmActTypes: IKnmActType[] = yield fetchKnmActTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_ACT_TYPES, knmActTypes));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_ACT_TYPES));
  }
}

function* fetchPmProfActTypesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.PM_PROF_ACT_TYPES));
  try {
    const pmProfActTypes: IKnmActType[] = yield fetchPmProfActTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.PM_PROF_ACT_TYPES, pmProfActTypes));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.PM_PROF_ACT_TYPES));
  }
}

function* fetchKnmCanceledReasonsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_CANCELED_REASONS));
  try {
    const knmCanceledReasons: IKnmCanceledReason[] = yield fetchKnmCanceledReasons();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_CANCELED_REASONS, knmCanceledReasons));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_CANCELED_REASONS));
  }
}

function* fetchCountriesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.COUNTRIES));
  try {
    const countries: ICountry[] = yield fetchCountries();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.COUNTRIES, countries));
  } catch (err) {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.COUNTRIES));
  }
}

function* fetchTerminationReasonsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.TERMINATION_REASONS));
  try {
    const terminationReasons: ITerminationReason[] = yield fetchTerminationReasons();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.TERMINATION_REASONS, terminationReasons));
  } catch (err) {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.TERMINATION_REASONS));
  }
}

function* fetchGenericReasonsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.GENERIC_REASONS));
  try {
    const genericReasons: IGenericReason[] = yield fetchGenericReasons();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.GENERIC_REASONS, genericReasons));
  } catch (err) {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.GENERIC_REASONS));
  }
}

function* fetchDecisionGenericReasonsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS));
  try {
    const genericReasons: IGenericReason[] = yield fetchGenericReasons(true);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS, genericReasons));
  } catch (err) {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS));
  }
}

function* fetchMandatoryCategoriesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.MANDATORY_CATEGORIES));
  try {
    const mandatoryCategories: IMandatoryCategory[] = yield fetchMandatoryCategories();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.MANDATORY_CATEGORIES, mandatoryCategories));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.MANDATORY_CATEGORIES));
  }
}

function* fetchInteractionCategoriesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.INTERACTION_CATEGORIES));
  try {
    const categories: IInteractionCategory[] = yield fetchInteractionCategories();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.INTERACTION_CATEGORIES, categories));
  } catch (err) {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.INTERACTION_CATEGORIES));
  }
}

function* fetchPmFormsConductingSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.PM_FORMS_CONDUCTING));
  try {
    const pmForms: IPmFormConducting[] = yield fetchPmFormsConducting();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.PM_FORMS_CONDUCTING, pmForms));
  } catch (err) {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.PM_FORMS_CONDUCTING));
  }
}

function* fetchJudgmentCourtLevelsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.JUDGMENT_COURT_LEVELS));
  try {
    const judgmentCourtLevels: IJudgmentCourtLevel[] = yield fetchJudgmentCourtLevels();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.JUDGMENT_COURT_LEVELS, judgmentCourtLevels));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_COURT_LEVELS));
  }
}

function* fetchJudgmentCourts() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.JUDGMENT_COURTS));
  try {
    const judgmentCourts: IJudgmentCourt[] = yield fetchJudgmentEnabledCourts();

    const creatableCourt: IJudgmentCourt = {
      id: -1,
      guid: '',
      code: 'NEW',
      courtType: null,
      title: 'Создать новый',
      address: null,
      web: null,
      rfRegion: null,
      erknmCourt: true,
      enabled: true,
    };

    judgmentCourts.unshift(creatableCourt);

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.JUDGMENT_COURTS, judgmentCourts));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_COURTS));
  }
}

function* fetchCreateJudgmentCourt(action: ActionType<typeof catalogCreateJudgmentCourt>) {
  function* funcTry() {
    const { data } = action.payload;

    const newCourt: IJudgmentCourt = yield fetchCreateCourt(data);

    yield put(setCreatedJudgmentCourt(newCourt));
    yield fetchJudgmentCourts();
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_COURTS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchJudgmentKindsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.JUDGMENT_KINDS));
  try {
    const judgmentKinds: IJudgmentKind[] = yield fetchJudgmentKinds();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.JUDGMENT_KINDS, judgmentKinds));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_KINDS));
  }
}

function* fetchJudgmentProsecutionTypesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES));
  try {
    const judgmentProsecutionTypes: IJudgmentProsecutionType[] = yield fetchJudgmentProsecutionTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES, judgmentProsecutionTypes));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES));
  }
}

function* fetchJudgmentPunishmentTypesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES));
  try {
    const judgmentPunishmentTypes: IJudgmentPunishmentType[] = yield fetchJudgmentPunishmentTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES, judgmentPunishmentTypes));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES));
  }
}

function* fetchJudgmentPunishmentIndexSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_INDEX));
  try {
    const judgmentPunishmentIndices: IJudgmentPunishmentIndex[] = yield fetchJudgmentPunishmentIndex();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_INDEX, judgmentPunishmentIndices));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_INDEX));
  }
}

function* fetchJudgmentCancellationInformationTypesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION));
  try {
    const judgmentCancellationInfo: IJudgmentCancellationInfo[] = yield fetchJudgmentCancellationInfo();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION, judgmentCancellationInfo));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION));
  }
}

function* fetchDistrictsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.DISTRICTS));
  try {
    const federalDistricts: IDistrict[] = yield fetchFederalDistricts();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.DISTRICTS, federalDistricts));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.DISTRICTS));
  }
}

function* fetchKnmAccessLevelsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_ACCESS_LEVELS));
  try {
    const knmAccessLevels: IKnmAccessLevel[] = yield fetchKnmAccessLevel();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_ACCESS_LEVELS, knmAccessLevels));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_ACCESS_LEVELS));
  }
}

function* fetchPmCanceledReasonsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.PM_CANCELED_REASONS));
  try {
    const pmCanceledReasons: IPmCanceledReason[] = yield fetchPmCanceledReasons();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.PM_CANCELED_REASONS, pmCanceledReasons));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.PM_CANCELED_REASONS));
  }
}

function* fetchViolationMaterialTypesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.VIOLATION_MATERIAL_TYPE));
  try {
    const violationMaterialTypes: IViolationMaterialType[] = yield fetchViolationMaterialTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.VIOLATION_MATERIAL_TYPE, violationMaterialTypes));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.VIOLATION_MATERIAL_TYPE));
  }
}

function* fetchViolationFixMethodsSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.VIOLATION_FIX_METHOD));
  try {
    const violationFixMethods: IViolationFixMethod[] = yield fetchViolationFixMethods();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.VIOLATION_FIX_METHOD, violationFixMethods));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.VIOLATION_FIX_METHOD));
  }
}

function* fetchViolationFixGradesSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.VIOLATION_FIX_GRADE));
  try {
    const violationFixGrades: IViolationFixGrade[] = yield fetchViolationFixGrades();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.VIOLATION_FIX_GRADE, violationFixGrades));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.VIOLATION_FIX_GRADE));
  }
}

function* fetchPassportMassCancelReasonSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.PASSPORT_MASS_CANCEL_REASON));
  try {
    const reasons: IPassportMassCancelReason[] = yield fetchPassportMassCancelReasons();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.PASSPORT_MASS_CANCEL_REASON, reasons));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.PASSPORT_MASS_CANCEL_REASON));
  }
}

function* fetchPassportMassDeleteReasonSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON));
  try {
    const reasons: IPassportMassCancelReason[] = yield fetchPassportMassDeleteReasons();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON, reasons));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON));
  }
}

function* fetchErvkOrdersSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.ERVK_ORDERS));
  try {
    const orders: IKnmOrder[] = yield fetchOrdersAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.ERVK_ORDERS, orders));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.ERVK_ORDERS));
  }
}

function* catalogOrdersRelationDictionariesGetHandler(action: ActionType<typeof catalogOrdersRelationDictionariesGet>) {
  const { orderId, orderVersionId } = action.payload;

  yield put(knmSetOrderVersionId(orderVersionId));

  if (orderId && orderVersionId) {
    const catalogStatus: CatalogStatusesEnum = yield select(
      getCatalogOrdersRelationDictionaries,
      orderId,
      orderVersionId,
    );

    if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
      yield fetchOrdersRelationDictionariesSaga(orderId, orderVersionId);
    }
  }
}

function* fetchOrdersRelationDictionariesSaga(orderId: string, orderVersionId: string) {
  function* funcTry() {
    const state: IRootState = yield select();

    yield put(catalogOrdersRelationDictionariesGetRequest(orderId, orderVersionId));

    const orderRelation: IOrderRelation = yield fetchOrdersRelationDictionaries(orderId, orderVersionId);

    const knoSupervisionUuid = getKnmKnoSupervisionUuid(state);
    const knoOrganizationDictVersionId = getKnmErknmKnoOrganizationDictVersionIdFormValue(state);
    const supervisionTypeDictVersionId = getKnmErknmSupervisionTypeDictVersionIdFormValue(state);
    const eventUuid = getKnmEventUuid(state)?.find(x => x);

    const knmSystemType = getKnmSystemType(state);
    const uniqueUuid = knmSystemType === KnmSystemTypesEnum.ERKNM ? eventUuid : knoSupervisionUuid;

    const reasonUuid =
      getKnmErknmReasonsFormValue(state)
        ?.map(x => x?.ervkUuid)
        ?.find(uuid => uuid) ||
      getKnmPmReasonsFormValue(state)
        ?.map(x => x.reason?.ervkUuid)
        ?.find(uuid => uuid) ||
      undefined;

    yield put(
      dictionariesDangerClassesItemGetSuccess(
        orderRelation.dangerClass,
        knoSupervisionUuid,
        reasonUuid,
        orderVersionId,
        undefined,
      ),
    );
    if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
      yield put(
        dictionariesKnmKindsItemGetSuccess(orderRelation.knmKinds, {
          knoVersionId: knoOrganizationDictVersionId,
          supervisionVersionId: supervisionTypeDictVersionId,
          conditionUuid: reasonUuid,
          orderVersionId,
        }),
      );
    }

    if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
      yield put(
        dictionariesProfKindsItemGetSuccess(orderRelation.profKinds, {
          knoVersionId: knoOrganizationDictVersionId,
          supervisionVersionId: supervisionTypeDictVersionId,
          orderVersionId,
        }),
      );

      yield put(
        dictionariesTargetEntityItemGetSuccess(orderRelation.targetEntities, {
          knoVersionId: knoOrganizationDictVersionId,
          supervisionVersionId: supervisionTypeDictVersionId,
          conditionUuid: reasonUuid,
          orderVersionId,
        }),
      );
    }

    yield put(dictionariesEventTypesItemGetSuccess(orderRelation.events, uniqueUuid, reasonUuid, orderVersionId));

    yield put(
      dictionariesSubjectTypesItemGetSuccess(orderRelation.objectTypes, knoSupervisionUuid, reasonUuid, orderVersionId),
    );

    yield put(
      dictionariesSubjectKindsItemGetSuccess(orderRelation.objectKinds, knoSupervisionUuid, reasonUuid, orderVersionId),
    );

    yield put(
      dictionariesSubjectSubKindsItemGetSuccess(
        orderRelation.objectSubKinds,
        knoSupervisionUuid,
        reasonUuid,
        orderVersionId,
      ),
    );

    yield put(
      dictionariesRiskCategoriesItemGetSuccess(
        orderRelation.riskCategories,
        eventUuid,
        reasonUuid,
        orderVersionId,
        undefined,
        undefined,
      ),
    );

    yield put(catalogOrdersRelationDictionariesGetSuccess(orderId, orderVersionId, orderRelation));
  }
  function* funcCatch() {
    yield put(catalogOrdersRelationDictionariesGetFailure(orderId, orderVersionId));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* catalogsKnmTypes248GetHandler(action: ActionType<typeof catalogKnmTypes248Get>) {
  const { params } = action.payload;
  const catalogStatus: CatalogStatusesEnum = yield select(getCatalogKnmTypes248Status, params);

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchKnmTypes248Saga(params);
  }
}

function* fetchKnmTypes248Saga(params: IKnmTypes248Params) {
  function* funcTry() {
    yield put(catalogKnmTypes248GetRequest(params));

    const data: IKnmType[] = yield fetchKnmTypesByKnoAndSupervision(
      params.knoVersionId,
      params.supervisionVersionId,
      true,
    );

    yield put(catalogKnmTypes248GetSuccess(params, data));
  }

  function* funcCatch() {
    yield put(catalogKnmTypes248GetFailure(params));
  }

  yield sagaWrapper({ funcTry, funcCatch });
}

function* knoOrganizationWithChildrenGetSaga() {
  const state: IRootState = yield select();
  const uuidKno = getPlanDataKnoOrganizationDictVersionId(state);
  const uuidSupervision = getPlanDataSupervisionDictVersionId(state);

  function* funcTry() {
    if (uuidKno && uuidSupervision) {
      yield put(catalogKnoOrganizationWithChildrenRequest(uuidKno, uuidSupervision));
      const data: IUserOrganisation[] = yield fetchKnoOrganizationWithTerritory(uuidKno, uuidSupervision);

      yield put(catalogKnoOrganizationWithChildrenSuccess(uuidKno, uuidSupervision, data));
    }
  }
  function* funcCatch() {
    if (uuidKno && uuidSupervision) {
      yield put(catalogKnoOrganizationWithChildrenFailure(uuidKno, uuidSupervision));
    }
  }

  yield sagaWrapper({ funcTry, funcCatch });
}

function* catalogsFnsRegistryOkvedCodesGetHandler(action: ActionType<typeof catalogFnsRegistryOkvedCodesGet>) {
  const { inn } = action.payload;
  const catalogStatus: CatalogStatusesEnum = yield select(getFnsRegistryOkvedCodesStatus, inn);

  if (!catalogStatus || catalogStatus === CatalogStatusesEnum.IDLE) {
    yield fetchFnsRegistryOkvedCodesSaga(inn);
  }
}

function* fetchFnsRegistryOkvedCodesSaga(inn: string) {
  function* funcTry() {
    yield put(catalogFnsRegistryOkvedCodesRequest(inn));
    const data: string[] | null = yield fetchFnsRegistrySearchOkved(inn);

    yield put(catalogFnsRegistryOkvedCodesSuccess(inn, data || []));
  }

  function* funcCatch() {
    yield put(catalogFnsRegistryOkvedCodesFailure(inn));
  }

  yield sagaWrapper({ funcTry, funcCatch });
}

function* fetchKnoLevelsSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNO_LEVELS));
    const knoLevels: IKnoLevel[] = yield fetchKnoLevels();

    const additionalKnoLevel: IKnoLevel = {
      id: 1000,
      code: 'ANY',
      name: 'Любое',
    };

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNO_LEVELS, [...knoLevels, additionalKnoLevel]));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNO_LEVELS));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmRemarksSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_REMARKS));
  try {
    const knmRemarks: IKnmRemark[] = yield fetchKnmRemarks();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_REMARKS, knmRemarks));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_REMARKS));
  }
}

function* fetchKnmRemarksAllSaga() {
  yield put(catalogGetRequest(CommonCatalogsNamesEnum.KNM_REMARKS_ALL));
  try {
    const knmRemarks: IKnmRemark[] = yield fetchKnmRemarksAll();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.KNM_REMARKS_ALL, knmRemarks));
  } catch {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.KNM_REMARKS_ALL));
  }
}

function* catalogGetErvkObjectsOfControlSelectOptionsSaga(
  action: ActionType<typeof catalogGetErvkObjectsOfControlSelectOptions>,
) {
  function* funcTry() {
    const { query, callback } = action.payload;
    const data: IErvkObjectsOfControl[] = yield findErvkObjectsOfControl(query);

    // TODO: возможно нужно переделать с ervkNumber на cosId,
    // но информацию на момент 01.26.2026 предоставить не смогли

    const selectOptions: ISelectOption[] = data.map(item => ({
      id: item.ervkNumber,
      value: item.ervkNumber,
      label: `${item.ervkNumber} - ${item.name}`,
    }));

    callback(selectOptions);
  }

  yield sagaWrapper({ funcTry });
}

function* fetchKnmUavTypesSaga() {
  function* funcTry() {
    yield put(catalogGetRequest(CommonCatalogsNamesEnum.UAV_TYPES));
    const uavType: IKnmUavType[] = yield fetchKnmUavTypes();

    yield put(catalogGetSuccess(CommonCatalogsNamesEnum.UAV_TYPES, uavType));
  }
  function* funcCatch() {
    yield put(catalogGetFailure(CommonCatalogsNamesEnum.UAV_TYPES));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}
